import React from 'react';
import { translate } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class CopyToClipboardBtn extends React.Component {
  state = { copied: false };

  render() {
    const { text, t } = this.props;
    const { copied } = this.state;

    return (
      <CopyToClipboard
        text={text}
        onCopy={() => {
          this.setState({ copied: true });

          // Clear the success message after a while.
          setTimeout(() => this.setState({ copied: false }), 1000);
        }}
      >
        <button className="c-btn c-btn--basic c-btn--effect">
          {copied ? t('admin.copyLinkSuccess') : t('admin.copyLinkBtn')}
        </button>
      </CopyToClipboard>
    );
  }
}

export default translate()(CopyToClipboardBtn);



// WEBPACK FOOTER //
// ./src/admin/invites/CopyToClipboardBtn.js